import(/* webpackMode: "eager", webpackExports: ["ApplicationShell"] */ "/workspace/repository/apps/enter-home/app/(application)/providers.tsx");
